// components/ImageGallery.js
"use client";
import React, { useState } from "react";
import ImageSlider from "./ImageSilder";

function ImageGallery({ images, gridClassName }) {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openSlider = (index) => {
    setCurrentImageIndex(index);
    setIsSliderOpen(true);
  };

  return (
    <>
      <div className={gridClassName || "grid grid-cols-1 gap-4 md:grid-cols-3"}>
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Gallery item ${index}`}
            height={600}
            className="w-[500px] h-[300px] object-cover"
            width={600}
            onClick={() => openSlider(index)}
          />
        ))}
      </div>

      {isSliderOpen && (
        <ImageSlider
          images={images}
          currentImageIndex={currentImageIndex}
          onClose={() => setIsSliderOpen(false)}
          setCurrentImageIndex={setCurrentImageIndex}
        />
      )}
    </>
  );
}

export default ImageGallery;
